import { mapState } from "vuex";

import { apiGet } from '@/services/api';

// module scope so concurrent consumers share one request instead of racing
let pendingFetch = null;

export default {
    created() {
        this.ensureBucketList();
    },
    methods: {
        async fetchBucketList() {
            if (pendingFetch) return pendingFetch;

            const store = this.$store;

            pendingFetch = apiGet('/api/buckets')
                .then(response => {
                    const bucketList = response.data || [];
                    store.dispatch('addBuckets', bucketList);
                    return bucketList;
                })
                .catch(error => {
                    // must not reject: a throw here used to abort App.created()
                    console.error('fetchBucketList failed', error);
                    return null;
                })
                .finally(() => {
                    pendingFetch = null;
                });

            return pendingFetch;
        },
        // lets a dropdown recover from a fetch that failed at app load
        async ensureBucketList() {
            if (!this.$store.getters.loggedIn) return null;
            if (this.buckets.length) return this.buckets;

            return this.fetchBucketList();
        },
        getBucketByPublicId(public_id) {
            return this.buckets.filter(bucket => bucket.public_id === public_id)[0]
        }
    },
    computed: {
        ...mapState({
            buckets: state => state.buckets.bucketList,
        }),
        bucketFormOptions() {
            let bucketOptions = []

            this.buckets.forEach(bucket => bucketOptions.push({
                text: bucket.name,
                value: bucket.public_id,
            }))

            return bucketOptions
        }
    }
}
